/**
 * Canonical public inbox for floai.studio (Namecheap Private Email).
 * Override per-role with NEXT_PUBLIC_SUPPORT_EMAIL, NEXT_PUBLIC_PRIVACY_EMAIL, etc. if you split inboxes later.
 */
export const OFFICIAL_SITE_EMAIL = 'info@floai.studio';

export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? OFFICIAL_SITE_EMAIL;

/** Server: where contact-form submissions are delivered (single support inbox). */
export function getContactInboxEmail(): string {
  return process.env.CONTACT_INBOX_EMAIL ?? process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? OFFICIAL_SITE_EMAIL;
}
export const PRIVACY_EMAIL = process.env.NEXT_PUBLIC_PRIVACY_EMAIL ?? OFFICIAL_SITE_EMAIL;
export const SECURITY_EMAIL = process.env.NEXT_PUBLIC_SECURITY_EMAIL ?? OFFICIAL_SITE_EMAIL;
/** Transactional “From”; defaults to official inbox until a dedicated noreply mailbox exists. */
export const NOREPLY_EMAIL = process.env.NEXT_PUBLIC_NOREPLY_EMAIL ?? OFFICIAL_SITE_EMAIL;

/** Default public site URL when env is unset (referral links, etc.). */
export const DEFAULT_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? 'https://floai.studio';

/**
 * User-facing refund rules: narrow window from first charge (no rolling “30 days” each cycle);
 * renewals / late-in-period requests limited.
 */
export const REFUND_POLICY_USER_SUMMARY =
  'You may request a full refund within 14 calendar days of your first paid charge only (after any trial). That window does not reset each billing cycle. Completed subscription periods are non-refundable—use Manage billing to cancel before renewal if you do not want the next charge. Requests made within 5 calendar days before a scheduled renewal may be limited to stopping the upcoming charge rather than refunding time already used in the current period, except where law requires otherwise.';
